import {Typography} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  vmtLabels: {
    color: '#5d9d52',
    marginTop: 5,
    marginBottom: 5,
    marginLeft: -5
  },
  vmtLinks: {
    marginRight: 5,
    marginLeft: 5,
    cursor: "pointer"
  }
}));

function VmtLabels({vertical, macrotema, tema, setScrollToObject, vmtSelection, setNavigationStatus}) {

  const classes = useStyles();
  return (<Typography className={classes.vmtLabels}>
    <Link className={classes.vmtLinks}
          onClick={() => {
            vmtSelection(vertical);
            setNavigationStatus('vertical_detail')
          }}
    >
      {vertical}
    </Link>
    >
    <Link className={classes.vmtLinks}
          onClick={() => {
            vmtSelection(vertical);
            setNavigationStatus('vertical_detail');
            setScrollToObject((macrotema + vertical).concat('treeItem'));
          }}>
      {macrotema}
    </Link>
    >
    <Link className={classes.vmtLinks}
          onClick={() => {
            vmtSelection(vertical);
            setNavigationStatus('vertical_detail');
            setScrollToObject((tema + macrotema + vertical).concat('treeItem'));
          }}>
      {tema}
    </Link>

  </Typography>);
}

export default VmtLabels;